import { Inject, Injectable } from '@angular/core';
import { CwtSubCrudContract, CwtSubCrudService } from '@cawita/core-front/api';
import { CwtStore } from '@cawita/core-front/state';
import { User, UserSession } from '@shared/models';

export type UserState = {
    user: User;

}

@Injectable({ providedIn: 'root' })
export class LoggedUserStore extends CwtStore<UserState> {
    constructor() {
        super({
            initialized: false,
            loading: false,
            user: null
        });
    }

    public init(user: User) {
        this.setState(c => ({
            ...c,
            initialized: true,
            loading: false,
            user: new User(user)
        }));
    }

    public update(userData: User | Partial<User>) {
        this.setState(c => ({
            ...c,
            user: new User({
                ...(c.user),
                ...(userData ?? {})
            })
        }))
    }

    public clear() {
        this.setState(c => ({
            ...c,
            initialized: false,
            loading: false,
            user: null
        }));
    }

}